/**
 * Aviso legal modo portal (revisión / referencia). Persistencia en localStorage.
 */
export const PORTAL_DISCLAIMER_VERSION = '2'
export const PORTAL_DISCLAIMER_DISMISS_DAYS = 7

const STORAGE_KEY = 'udv.portalDisclaimerAck'

function canUseStorage() {
  try {
    return typeof window !== 'undefined' && !!window.localStorage
  } catch (e) {
    return false
  }
}

/**
 * @returns {{ version: string, until: number, at: number }|null}
 */
export function getPortalDisclaimerAck() {
  if (!canUseStorage()) return null
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const v = JSON.parse(raw)
    if (!v || typeof v !== 'object') return null
    return v
  } catch (e) {
    return null
  }
}

/**
 * Modal dismiss reciente (misma versión de texto).
 * @returns {boolean}
 */
export function isPortalDisclaimerDismissed() {
  const ack = getPortalDisclaimerAck()
  if (!ack || ack.version !== PORTAL_DISCLAIMER_VERSION) return false
  const until = Number(ack.until)
  return Number.isFinite(until) && until > Date.now()
}

/**
 * @returns {boolean}
 */
export function shouldShowPortalDisclaimerModal() {
  return !isPortalDisclaimerDismissed()
}

/**
 * @param {number} [days]
 */
export function dismissPortalDisclaimer(days = PORTAL_DISCLAIMER_DISMISS_DAYS) {
  if (!canUseStorage()) return
  const d = Number(days)
  const span =
    (Number.isFinite(d) && d > 0 ? d : PORTAL_DISCLAIMER_DISMISS_DAYS) * 86400000
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        version: PORTAL_DISCLAIMER_VERSION,
        until: Date.now() + span,
        at: Date.now(),
      })
    )
  } catch (e) {
    /* ignore */
  }
}

export function clearPortalDisclaimerAck() {
  if (!canUseStorage()) return
  try {
    window.localStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    /* ignore */
  }
}
